import * as Animate from "react-reveal";
import Avatar1 from "../../../assets/images/png/avatars/1.webp";
import Avatar2 from "../../../assets/images/png/avatars/2.webp";
import Avatar3 from "../../../assets/images/png/avatars/3.webp";
import Avatar4 from "../../../assets/images/png/avatars/4.webp";

const steps = [
  {
    number: "01",
    title: "Share your team",
    desc:
      "Tell us where your people work, how they are engaged and how payroll runs today.",
    img: Avatar1,
  },
  {
    number: "02",
    title: "Set up together",
    desc:
      "Your Utiva specialist coordinates worker details, records and supported payout options.",
    img: Avatar2,
  },
  {
    number: "03",
    title: "Review payroll",
    desc: "Your team checks the payroll summary and approves the final payout.",
    img: Avatar3,
  },
  {
    number: "04",
    title: "Pay and stay informed",
    desc:
      "Workers receive their payout while your team keeps a clear record of the cycle.",
    img: Avatar4,
    noArrow: true,
  },
];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayProcessSection = () => {
  return (
    <section
      className="bg-white py-16 lg:py-[105px] px-6 lg:px-8"
      id="how-it-works"
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="max-w-[920px] mb-10 lg:mb-[47px]">
            <p className="flex items-center gap-3 text-primary text-[15px] font-black tracking-[0.11em] uppercase mb-4">
              <span className="w-10 h-[3px] bg-secondary inline-block shrink-0"></span>
              How It Works
            </p>
            <h2
              className="text-primary tracking-[-0.052em] leading-[1.04] font-black"
              style={{ fontSize: "clamp(40px, 4.5vw, 65px)" }}
            >
              From team setup to payday,{" "}
              <mark style={markStyle}>together.</mark>
            </h2>
          </div>
        </Animate.Fade>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-b border-[#dce3f1] m-0 p-0 list-none">
          {steps.map((step, index) => {
            const isLast = index === steps.length - 1;
            return (
              <Animate.Fade bottom key={step.number}>
                <li
                  className={`border-l border-r border-b lg:border-b-0 border-[#dce3f1] relative p-6 min-h-[280px] lg:min-h-[350px] ${
                    isLast ? "" : "lg:border-r-0"
                  }`}
                  style={{ background: isLast ? "#edf2ff" : "transparent" }}
                >
                  <span className="text-[#986500] text-[16px] font-black">
                    {step.number}
                  </span>
                  <img
                    src={step.img}
                    alt=""
                    className="rounded-full border-[3px] border-white object-cover block mt-[42px]"
                    style={{
                      width: "56px",
                      height: "56px",
                      boxShadow: "0 9px 22px rgba(24,30,70,0.14)",
                    }}
                  />
                  <h3 className="text-primary text-2xl font-bold leading-[1.28] mt-4 mb-[13px]">
                    {step.title}
                  </h3>
                  <p className="text-[#5c6274] text-[16px] leading-[1.7]">
                    {step.desc}
                  </p>
                  {!step.noArrow && (
                    <b
                      className="hidden lg:block text-primary font-normal absolute"
                      style={{
                        fontSize: "23px",
                        top: "150px",
                        right: "-13px",
                        zIndex: 2,
                      }}
                    >
                      →
                    </b>
                  )}
                </li>
              </Animate.Fade>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default PayProcessSection;
